import {obtenerIDLocal} from "./obtenerIDLocal";
import {doc, setDoc, updateDoc} from "firebase/firestore";
import {fire} from "../../fire";

export const registrarDatos = async ({datos,coleccion='metricas'}) => {

    let uid = obtenerIDLocal()
    let referencia = doc(fire, coleccion, uid)

    datos.id = uid
    try {
        await updateDoc(referencia, datos);
    } catch (err) {
        await setDoc(referencia, datos);
    }

}